import {SolicitationFileViewDTO} from "../../types/solicitation/solicitationFile";
import {HttpAxiosRequest} from "../httpAxiosBase";

export const HttpClientFile = {
    getEndpoint: (url = "", clientId: number) => `cliente/${clientId}/archivo${url}`,
    
    getSolicitationsFiles: (clientId: number) : Promise<SolicitationFileViewDTO[]> => {
        return HttpAxiosRequest.get(
            HttpClientFile.getEndpoint('/solicitudes', clientId)
        )
    }
}